import { ConsentOverlay, handleEmbed } from '@3pc/consent-overlay';
const initConsentOverlays = () => {
  const overlays = document.querySelectorAll('[data-consent-type]');
  const overlayInstances = [];

  overlays.length &&
    overlays.forEach(overlay => {
      const container = overlay;

      const overlayInstance = new ConsentOverlay({
        container,
        nameSpace: 'duk',
        onActivation: (container = this.container, consentType) => {
          handleEmbed(container, true);
        },
        onDeactivation: (container, consentType) => {
          handleEmbed(container, false);

          // Focus container
          container.setAttribute('tabindex', -1);
          container.focus();
        },
      });

      overlayInstance.init();
      overlayInstances.push(overlayInstance);
    });
  return overlayInstances;
};
export { initConsentOverlays };
